import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";

/** Renders one catalogue question (text / textarea / number / select / multiselect) — shared by the profile and new-document forms. */
export default function HseQuestionField({ q, value, onChange, testPrefix = "hse-q" }) {
  const id = `${testPrefix}-${q.key}`;
  const label = <Label htmlFor={id} className="text-xs">{q.label}{q.required && <span className="text-red-600"> *</span>}</Label>;
  if (q.type === "multiselect") {
    const sel = new Set(value || []);
    const toggle = (o) => { const n = new Set(sel); n.has(o) ? n.delete(o) : n.add(o); onChange([...n]); };
    return (
      <div className="space-y-1.5" data-testid={id}>
        {label}
        <div className="flex flex-wrap gap-1.5">
          {q.options.map(o => (
            <button key={o} type="button" onClick={() => toggle(o)} aria-pressed={sel.has(o)} data-testid={`${id}-opt-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className={`text-[11px] px-2.5 py-1 rounded-full border transition-colors ${sel.has(o) ? "bg-primary text-primary-foreground border-primary" : "border-border hover:bg-muted"}`}>
              {o}
            </button>
          ))}
        </div>
        {q.help && <p className="text-[10px] text-muted-foreground">{q.help}</p>}
      </div>
    );
  }
  if (q.type === "select") {
    return (
      <div className="space-y-1.5">
        {label}
        <select id={id} value={value || ""} onChange={e => onChange(e.target.value)} data-testid={id}
          className="w-full h-9 rounded-md border border-input bg-background px-3 text-sm">
          <option value="">Select…</option>
          {q.options.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
      </div>
    );
  }
  if (q.type === "textarea") {
    return (
      <div className="space-y-1.5">
        {label}
        <Textarea id={id} value={value || ""} onChange={e => onChange(e.target.value)} placeholder={q.placeholder} rows={3} className="text-sm" data-testid={id} />
        {q.help && <p className="text-[10px] text-muted-foreground">{q.help}</p>}
      </div>
    );
  }
  return (
    <div className="space-y-1.5">
      {label}
      <Input id={id} type={q.type === "number" ? "number" : "text"} value={value ?? ""} onChange={e => onChange(q.type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)}
        placeholder={q.placeholder} className="h-9 text-sm" data-testid={id} />
    </div>
  );
}
